/**
 * Collapsible Element Extraction Component
 * Wrapper to make ElementExtraction collapsible like other tools
 */

import React, { useState } from 'react';
import { ChevronDown, ChevronRight, Search } from 'lucide-react';
import { ElementExtraction } from './ElementExtraction';
import { useViewerStore } from '@/store/viewerStore';

export function CollapsibleElementExtraction() {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const { isModelLoaded } = useViewerStore();

  return (
    <div className="bg-dark-100 rounded-lg border border-gray-700">
      {/* Header - Always Visible */}
      <button
        onClick={() => setIsCollapsed(!isCollapsed)}
        className="w-full px-4 py-3 flex items-center justify-between hover:bg-dark-200 transition-colors rounded-lg"
      >
        <div className="flex items-center gap-2">
          <Search className="w-5 h-5 text-green-400" />
          <span className="font-semibold text-gray-100">Element Extraction</span>
          <span className="text-xs text-gray-400"></span>
        </div>
        <div className="flex items-center gap-2">
          {!isCollapsed && (
            <span className="text-xs text-gray-400">
              {isModelLoaded ? '✓ Model Loaded' : '⚠ No Model'}
            </span>
          )}
          {isCollapsed ? (
            <ChevronRight className="w-5 h-5 text-gray-400" />
          ) : (
            <ChevronDown className="w-5 h-5 text-gray-400" />
          )}
        </div>
      </button>

      {/* Collapsible Content */}
      {!isCollapsed && (
        <div className="p-4 border-t border-gray-700 animate-fade-in">
          <ElementExtraction />
        </div>
      )}
    </div>
  );
}